import { stripLangPrefix } from '../i18n/locale';

export const isWikiPath = (pathname: string): boolean => /^\/wiki(\/|$)/.test(stripLangPrefix(pathname));
